var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contragents-roadmaps"},[_c('i-table',{attrs:{"show-header":false,"columns":_vm.columns,"data":_vm.roadmaps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }